import axios from 'axios'

const metaSelector = '.core-page-data'

function loadNextPage (selector) {
	if (nextPage()) {
		return loadItems(nextPage(), selector)
	}
}

function nextPage () {
	return $(metaSelector).data('next-page')
}

function baseUrl () {
	return $(metaSelector).data('base-url')
}

function currentPage () {
	return $(metaSelector).data('current-page')
}

function clearItems (selector) {
	$(selector).html('')
}

function loadItems (url, selector) {
	return axios.get(url, {
		headers: {
			'X-Request-Type': 'ajax',
		},
	}).then((response) => {
		let metaContainer = $(response.data).find(metaSelector)
		$(metaSelector).data(metaContainer.data())
		$(selector).append(metaContainer.find(selector).html());
		if (response.request && response.request.responseURL) {
			url = response.request.responseURL
		}
		history.replaceState(history.state, '', url);
	})
}

export { loadItems, loadNextPage, nextPage, clearItems, baseUrl, currentPage };